import { useResource } from "../../../Hooks/UseResource";

export default function TagValueResource() {
    const[resourceError, loading, getData, postData, uploadData] =useResource();

   const getTagValue =(tagName,shortName)=>{
        return getData( {url:'/public/tagName/:tagName/getTagValueByTagAndShortName',  params:{"tagName":tagName,"shortName":shortName}});       
   }

    return [getTagValue]

}